import type { TFunction } from 'i18next';

const duplicateAccountSignals = [
  /e013014/i,
  /entity already exists/i,
  /external_ids_default_project_id_lower_idx/i,
  /already in use/i,
  /already exists/i,
];

const rawDescopeErrorSignals = [
  /e013014/i,
  /\[e0\d+\]/i,
  /sqlstate/i,
  /rpc error/i,
  /duplicate key value/i,
  /unique constraint/i,
];

const isRawDescopeError = (errorText: string): boolean =>
  rawDescopeErrorSignals.some(signal => signal.test(errorText)) ||
  errorText.length > 300;

const isDescopeEntityChain = (errorText: string): boolean =>
  /entity already exists/i.test(errorText) &&
  /\[error:|failed (?:creating|to create)|descope/i.test(errorText);

const isDuplicateAccountError = (errorText: string): boolean =>
  duplicateAccountSignals.some(signal => signal.test(errorText)) &&
  (rawDescopeErrorSignals.some(signal => signal.test(errorText)) ||
    isDescopeEntityChain(errorText));

export type AuthErrorKind = 'duplicate-account' | 'generic' | 'passthrough';

export interface AuthErrorMessage {
  kind: AuthErrorKind;
  message: string | undefined;
  fallbackMessage?: string;
}

export const getAuthErrorMessage = (
  errorText: string | undefined,
  t: TFunction
): AuthErrorMessage => {
  if (!errorText) {
    return { kind: 'passthrough', message: errorText };
  }

  if (isDuplicateAccountError(errorText)) {
    return {
      kind: 'duplicate-account',
      message: t(
        'An account with these details already exists. Log in instead.'
      ),
      fallbackMessage: t('An account with these details already exists.'),
    };
  }

  if (isRawDescopeError(errorText)) {
    return {
      kind: 'generic',
      message: t('Something went wrong. Please try again.'),
    };
  }

  return { kind: 'passthrough', message: errorText };
};
